export enum CheckoutEvent {
  CHECKOUT_SUBMITTED = 'CHECKOUT_SUBMITTED',
}
